import React, { useEffect } from 'react';
import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import HomePage from './pages/HomePage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';

const CARDAPIO_URL = process.env.REACT_APP_CARDAPIO_URL || 'https://cardapio.bloisetech.com.br';
const HUB_URL = process.env.REACT_APP_HUB_URL || 'https://app.bloisetech.com.br';
const ADMIN_URL = process.env.REACT_APP_ADMIN_URL || 'https://admin.bloisetech.com.br';

function ExternalRedirect({ baseUrl, stripPrefix = '' }) {
  const location = useLocation();

  useEffect(() => {
    let pathname = location.pathname;
    if (stripPrefix && pathname.startsWith(stripPrefix)) {
      pathname = pathname.slice(stripPrefix.length);
    }
    if (pathname === '/') pathname = '';

    window.location.replace(`${baseUrl}${pathname}${location.search}${location.hash}`);
  }, [baseUrl, location.hash, location.pathname, location.search, stripPrefix]);

  return (
    <div className="min-h-screen bg-[#fdfbf7] flex items-center justify-center">
      <div className="w-8 h-8 border-2 border-[#FC5301] border-t-transparent rounded-full animate-spin" />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/privacidade" element={<PrivacyPage />} />
        <Route path="/termos" element={<TermsPage />} />

        <Route path="/appcardapio/*" element={<ExternalRedirect baseUrl={CARDAPIO_URL} stripPrefix="/appcardapio" />} />
        <Route path="/login" element={<ExternalRedirect baseUrl={HUB_URL} />} />
        <Route path="/change-password" element={<ExternalRedirect baseUrl={HUB_URL} />} />
        <Route path="/forgot-password" element={<ExternalRedirect baseUrl={HUB_URL} />} />
        <Route path="/admin/*" element={<ExternalRedirect baseUrl={ADMIN_URL} />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
